import CustomCell from 'src/components/Table/CustomCell';
import { sortingMethods } from 'src/constants/table';

export const DEVICE_UNMATCHED_FILES_COLUMNS = [
  {
    key: 'fileName',
    label: 'File Name',
    sortable: true,
    sortKey: 'fileName',
    width: '46%',
  },
  {
    key: 'lastSeen',
    label: 'Last Seen',
    sortable: true,
    sortKey: 'lastSeen',
    width: '18%',
  },
  {
    key: 'last30Count',
    label: 'Last 30 Count',
    sortable: true,
    sortKey: 'last30Count',
    width: '18%',
  },
  {
    key: 'last90Count',
    label: 'Last 90 Count',
    sortable: true,
    sortKey: 'last90Count',
    width: '18%',
  },
];

export const columnsOrder = [
  { name: 'processName', styles: { wordBreak: 'break-word' } },
  { name: 'fullFilePath', styles: { wordBreak: 'break-word' } },
  { name: 'deviceWdacEventsCount', isNumeric: true },
  {
    name: 'eventSystemTime',
    styles: { minWidth: '70px' },
  },
];

export const headings = [
  {
    title: 'Process Name',
    name: 'processName',
    hasSorting: false,
    width: '35%',
  },
  {
    title: 'File Name',
    name: 'fullFilePath',
    hasSorting: false,
    width: '35%',
  },
  {
    title: 'WDAC Events Count',
    name: 'deviceWdacEventsCount',
    hasSorting: false,
    width: '15%',
  },
  {
    title: 'Date',
    name: 'eventSystemTime',
    hasSorting: false,
    width: '15%',
  },
];

export const MAIN_TABLE_HEADERS = [
  { title: 'File Name', name: 'filePath', width: '26%' },
  { title: 'SHA-256 Hash', name: 'sha256', width: '40%' },
  {
    title: 'Event System Time',
    name: 'eventSystemTime',
    hasSorting: true,
    sortMethod: sortingMethods.initial,
    Component: CustomCell,
    field: 'FilterUnmatchedFiles',
    sortingCellField: 'event_system_time',
    sortFieldName: 'OrderWdacQuery',
    width: '18%',
  },
  {
    title: 'Count',
    name: 'count',
    hasSorting: false,
    sortMethod: sortingMethods.initial,
    Component: CustomCell,
    field: 'FilterUnmatchedFiles',
    sortingCellField: 'wdac_items_total_count',
    sortFieldName: 'OrderWdacQuery',
    width: '8%',
  },
  { title: '', name: 'actions', width: '8%' },
];
